import { HdrAuto } from '@mui/icons-material';
import LibraryBooks from '@mui/icons-material/LibraryBooks';
import ListAlt from '@mui/icons-material/ListAlt';
import Queue from '@mui/icons-material/Queue';
import RestorePage from '@mui/icons-material/RestorePage';
import { makeObservable, observable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroSituacaoInclusaoPauta extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Situação para inclusão em pauta';
    }

    getIconeFiltroRapido() {
        return <LibraryBooks />;
    }

    opcoesFiltro = FiltroSituacaoInclusaoPauta.#carregarOpcoes();

    filtroRapido = {
        opcoes: this.getOpcoesFiltro('valor', 'cor')
    };

    static #carregarOpcoes() {
        return [
            { valor: 'APTO_PAUTA', cor: 'black', icone: <ListAlt style={{ fill: 'black' }} /> },
            { valor: 'REMANESCENTE', cor: 'black', icone: <RestorePage style={{ fill: 'black' }} /> },
            { valor: 'APTO_JULGAMENTO', cor: 'black', icone: <Queue style={{ fill: 'black' }} /> },
            { valor: 'AGRAVO_PROVIDO', cor: 'black', icone: <HdrAuto style={{ fill: 'black' }} /> }
        ];
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        return registro.tipoInclusao;
    }

    getDescricao(valor) {
        switch (valor) {
            case 'APTO_PAUTA':
                return 'Aptos para pauta';
            case 'REMANESCENTE':
                return 'Remanescentes';
            case 'APTO_JULGAMENTO':
                return 'Aptos para sessão (PJe)';
            case 'AGRAVO_PROVIDO':
                return 'Agravo provido em sessão anterior (SIJ)';
            default:
                return '';
        }
    }
}
